<div>
  <google-pay-button [ngClass]="
      bookingType !== 'amend' && bookingAmendSection !== 'booker'
        ? 'gPayBtnStandard'
        : 'gPayBtnAmend'
    " id="gPayBtn" environment="TEST" buttonType="plain" buttonColor="black" buttonSizeMode="fill"
    (loadpaymentdata)="onLoadPaymentData($event)" [paymentRequest]="paymentRequest"
    [paymentAuthorizedCallback]="onPaymentAuthorizedData" (error)="onError($event)" [clickCallback]="onPressButton"
    value="Pay">
  </google-pay-button>
</div>